import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Icon } from "@iconify/react";
import { IoMailOutline } from "react-icons/io5";

export const SidebarItems = [
  {
    key: 1,
    text: "Dashboard",
    link: "/customer/dashboard",
    icon: <Icon icon="radix-icons:dashboard" width="20" height="20" />,
    nestedItem: null,
  },
  {
    key: 2,
    text: "Products",
    link: "/customer/products",
    icon: <Icon icon="icons8:price-tag" width="20" height="20" />,
    isOpen: <ExpandMore />,
    isClose: <ExpandLess />,
    nestedItem: [
      {
        key: 100,
        text: "Products",
        route: "products",
        link: "/customer/products",
        icon: <Icon icon="icons8:price-tag" width="20" height="20" />,
        isOpen: false,
        nestedItem: null,
      },
      // {
      //   key: 101,
      //   text: "Import List",
      //   route: "import-list",
      //   link: "/customer/products/import-list",
      //   icon: <Icon icon="fluent:cube-add-20-regular" width="20" height="20" />,
      //   isOpen: false,
      //   nestedItem: null,
      // },
      {
        key: 103,
        text: "Live Products",
        route: "live-products",
        link: "/customer/products/live-products",
        icon: <Icon icon="fluent-mdl2:product" width="20" height="20" />,
        isOpen: false,
        nestedItem: null,
      },
      {
        key: 104,
        text: "Quality Check",
        route: "quality-check",
        link: "/customer/products/quality-check",
        icon: <Icon icon="fluent:image-multiple-20-regular" width="20" height="20" />,
        isOpen: false,
        nestedItem: null,
      },
      // {
      //   key: 103,
      //   text: "Sourcing Request",
      //   route: "sourcing-request",
      //   link: "/customer/products/sourcing-request",
      //   icon: (
      //     <Icon icon="carbon:carbon-for-ibm-product" width="20" height="20" />
      //   ),
      //   isOpen: false,
      //   nestedItem: null,
      // },
    ],
  },
  {
    key: 3,
    text: "Orders",
    link: "/customer/orders",
    // iconImg: orderIcon,
    icon: <Icon icon="carbon:cube" width="20" height="20" />,
    isOpen: <ExpandMore />,
    isClose: <ExpandLess />,
    nestedItem: [
      {
        key: 100,
        text: "Orders",
        route: "orders",
        link: "/customer/orders",
        icon: <Icon icon="carbon:cube" width="20" height="20" />,
        isOpen: false,
        indentifier: "nestedItem",
        nestedItem: null,
      },
      {
        key: 101,
        text: "Dispute List",
        route: "dispute-list",
        link: "/customer/orders/dispute-list",
        icon: <Icon icon="bi:list-ul" width="20" height="20" />,
        isOpen: false,
        nestedItem: null,
      },
      {
        key: 102,
        text: "Order Tracking",
        route: "order-tracking",
        link: "/customer/orders/order-tracking",
        icon: <Icon icon="ep:location-information" width="20" height="20" />,
        isOpen: false,
        nestedItem: null,
      },
      {
        key: 103,
        text: "Returned Orders",
        route: "returned-to-overseas-warehouse",
        link: "/customer/orders/returned-to-overseas-warehouse",
        icon: <Icon icon="streamline:warehouse-1" width="20" height="20"/> ,
        isOpen: false,
        nestedItem: null,
      },
    ],
  },
  {
    key: 4,
    text: "Payments",
    link: "/customer/payments",
    icon: <Icon icon="fluent:payment-24-regular" width="20" height="20" />,
    nestedItem: null,
  },
  {
    key: 5,
    text: "Notifications",
    link: "/customer/notifications",
    icon: <Icon icon="carbon:notification" width="20" height="20" />,
    nestedItem: null,
  },
  // {
  //   key: 6,
  //   text: "Extra",
  //   icon: <FlipToFrontIcon width="20px" height="20px" />,
  //   isOpen: <ExpandMore />,
  //   isClose: <ExpandLess />,
  //   nestedItem: [
  //     {
  //       key: 100,
  //       text: "Branding",
  //       link: "/customer/extra/branding",
  //       route: "branding",
  //       icon: <FiClipboard fontSize="20px" />,
  //       isOpen: false,
  //       nestedItem: null,
  //     },
  //     // {
  //     //   key: 101,
  //     //   text: "Bundle",
  //     //   link: "/customer/extra/bundle",
  //     //   route: "bundle",
  //     //   icon: <FiClipboard fontSize="20px" />,
  //     //   isOpen: false,
  //     //   nestedItem: null,
  //     // },
  //     // {
  //     //   key: 102,
  //     //   text: "Bulk Purchase",
  //     //   link: "/customer/extra/bulk",
  //     //   route: "bulk",
  //     //   icon: <Icon icon="akar-icons:shipping-box-v1" width="20" height="20" />,
  //     //   nestedItem: null,
  //     // },
  //     // {
  //     //   key: 103,
  //     //   text: "Extra storage",
  //     //   route: "storage",
  //     //   link: "/customer/extra/storage",
  //     //   icon: <Apps width="20px" height="20px" />,
  //     //   nestedItem: null,
  //     // },
  //   ],
  // },
];

// Admin Routing
export const AdminSidebarItems = [
  {
    key: 1,
    text: "Dashboard",
    link: "/admin/dashboard",
    icon: <Icon icon="radix-icons:dashboard" width="20" height="20" />,
    nestedItem: null,
  },
  {
    key: 2,
    text: "Products",
    link: "/admin/products",
    icon: <Icon icon="icons8:price-tag" width="20" height="20" />,
    // isOpen: <ExpandMore />,
    // isClose: <ExpandLess />,
    nestedItem:null
    // nestedItem: [
    //   {
    //     key: 21,
    //     text: "Sourcing Request",
    //     route: "sourcing-request",
    //     link: "/admin/products/sourcing-request",
    //     icon: (
    //       <Icon icon="carbon:carbon-for-ibm-product" width="20" height="20" />
    //     ),
    //     isOpen: false,
    //     nestedItem: null,
    //   },
    // ],
  },
  // {
  //   key: 2,
  //   text: "Sourcing List",
  //   icon: <Icon icon="gridicons:product" width="20" height="20" />,
  //   isOpen: <ExpandMore />,
  //   isClose: <ExpandLess />,
  //   nestedItem: [
  //     {
  //       key: 100,
  //       text: "Sourcing List",
  //       link: "/admin/sourcing-list",
  //       icon: <FiClipboard fontSize="20px" />,
  //       isOpen: false,
  //       nestedItem: null,
  //     },
  //     {
  //       key: 101,
  //       text: "Requotation",
  //       link: "/admin/sourcing-list/requotation",
  //       icon: <FiClipboard fontSize="20px" />,
  //       isOpen: false,
  //       nestedItem: null,
  //     },
  //     {
  //       key: 102,
  //       text: "New Sourcing Request",
  //       link: "/admin/sourcing-list/new-sourcing-request",
  //       icon: <FiClipboard fontSize="20px" />,
  //       isOpen: false,
  //       nestedItem: null,
  //     },
  //   ],
  // },

  {
    key: 3,
    text: "Orders",
    link: "/admin/orders",
    // iconImg: orderIcon,
    icon: <Icon icon="carbon:cube" width="20" height="20" />,
    isOpen: <ExpandMore />,
    isClose: <ExpandLess />,
    nestedItem: [
      {
        key: 100,
        text: "Orders",
        route: "orders",
        link: "/admin/orders",
        icon: <Icon icon="carbon:cube" width="20" height="20" />,
        isOpen: false,
        indentifier: "nestedItem",
        nestedItem: null,
      },
      {
        key: 100,
        text: "Batch Process List",
        route: "batch-process",
        link: "/admin/orders/batch-process",
        icon: <Icon icon="clarity:process-on-vm-line" width="20" height="20" />,
        isOpen: false,
        indentifier: "nestedItem",
        nestedItem: null,
      },
      {
        key: 101,
        text: "Dispute List",
        route: "dispute-list",
        link: "/admin/orders/dispute-list",
        icon: <Icon icon="bi:list-ul" width="20" height="20" />,
        isOpen: false,
        nestedItem: null,
      },
      // {
      //   key: 102,
      //   text: "Order Tracking",
      //   route: "order-tracking",
      //   link: "/admin/orders/order-tracking",
      //   icon: <Icon icon="ep:location-information" width="20" height="20" />,
      //   isOpen: false,
      //   nestedItem: null,
      // },
      {
        key: 103,
        text: "Returned to overseas",
        route: "returned-to-overseas-warehouse",
        link: "/admin/orders/returned-to-overseas-warehouse",
        icon: <Icon icon="streamline:warehouse-1" width="20" height="20"/> ,
        isOpen: false,
        nestedItem: null,
      },
      // {
      //   key: 102,
      //   text: "Order Tracking",
      //   route: "order-tracking",
      //   link: "/admin/orders/order-tracking",
      //   icon: <Icon icon="ep:location-information" width="20" height="20" />,
      //   isOpen: false,
      //   nestedItem: null,
      // },
    ],
  },
  // {
  //   key: 4,
  //   text: "Bulk Purchase",
  //   link: "/admin/bulk-purchase",
  //   icon: <Icon icon="akar-icons:shipping-box-v1" width="20" height="20" />,
  //   nestedItem: null,
  // },
  
  {
    key: 4,
    text: "Payments",
    link: "/admin/payments",
    icon: <Icon icon="fluent:payment-24-regular" width="20" height="20" />,
    nestedItem: null,
  },
  // {
  //   key: 5,
  //   text: "Notification",
  //   link: "/admin/notification",
  //   icon: <Icon icon="carbon:notification" width="20" height="20" />,
  //   nestedItem: null,
  // },
  {
    key: 5,
    text: "Shipping",
    link: "/admin/shipping",
    icon: <Icon icon="fa-solid:shipping-fast" width="20" height="20" />,
    nestedItem: null,
  },
  {
    key: 6,
    text: "Users",
    link: "/admin/users",
    icon: <Icon icon="ph:users-three-light" width="20" height="20" />,
    nestedItem: null,
  },
  {
    key: 7,
    text: "Reports",
    link: "/admin/reports",
    icon: <Icon icon="fluent:payment-24-regular" width="20" height="20" />,
    nestedItem: null,
  },
  {
    key: 8,
    text: "Affiliates",
    link: "/admin/referrals",
    icon: <Icon icon="healthicons:referral" width="20" height="20" />,
    nestedItem: null,
  },
  {
    key: 9,
    text: "Mail Trackers",
    link: "/admin/mail-trackers",
    icon: <IoMailOutline style={{width:"20px", height:"20px"}}/>,
    nestedItem: null,
  },
  // {
  //   key: 7,
  //   text: "Affiliate Programs",
  //   link: "/admin/affiliate-program",
  //   icon: <Icon icon="carbon:notification" width="20" height="20" />,
  //   nestedItem: null,
  // },
];
